import {View, Text, StyleSheet, Svg, Rect, Line} from "@react-pdf/renderer";
import React from "react";


interface IMedicalHistoryPdfProps {
    medicalHistoryOptionsList: any[],
    clientMedicalHistoryDetails: any
}

const styles = StyleSheet.create({
    checkboxContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 8,
    },
    checkbox: {
        width: 14,
        height: 14,
        marginRight: 10,
    },
    label: {
        fontSize: 10,
        flexWrap: "wrap",
    },
});

const Checkbox = ({checked}: { checked: boolean }) => (
    <Svg style={styles.checkbox} viewBox="0 0 14 14">
        <Rect x="1" y="1" width="12" height="12" stroke="#000" fill="white"/>
        {checked && (
            <>
                <Line x1="3" y1="7" x2="6" y2="10" stroke="#000" strokeWidth="1.5"/>
                <Line x1="6" y1="10" x2="11" y2="4" stroke="#000" strokeWidth="1.5"/>
            </>
        )}
    </Svg>
);


const MedicalHistoryPdf = (props: IMedicalHistoryPdfProps) => {

    const {medicalHistoryOptionsList, clientMedicalHistoryDetails} = props;

    const selectedIds = clientMedicalHistoryDetails?.medical_history?.questions || [];

    return (
        <View>
            <Text
                style={{
                    fontSize: 10,
                    paddingLeft: 12,
                    fontFamily: "Helvetica-Bold",
                    textDecoration: "underline",
                }}
            >
                MEDICAL HISTORY:
            </Text>
            <Text style={{paddingLeft: 20, fontSize: 10, paddingTop: 8, paddingBottom: 8}}>
                Have you ever had or do you currently have:
            </Text>

            <View
                style={{
                    border: "1px solid #000",
                    flexDirection: "row",
                    padding: 8,
                    marginLeft: 20,
                    width: "95%",
                }}
            >
                <View style={{width: "50%", paddingRight: 30}}>
                    {medicalHistoryOptionsList?.slice(0, 24).map((option, index) => (
                        <View style={styles.checkboxContainer} key={option._id}>
                            <Checkbox checked={selectedIds.includes(option._id)}/>
                            <Text style={styles.label}>{option.title}</Text>
                        </View>
                    ))}
                    <View style={styles.checkboxContainer}>
                        <Checkbox checked={clientMedicalHistoryDetails?.medical_history?.comments}/>
                        <Text style={styles.label}>Any other illnesses or conditions not listed above</Text>
                    </View>
                    <View>
                        {clientMedicalHistoryDetails?.medical_history?.comments &&
                            <View style={{fontSize: 10}}>
                                <View>{clientMedicalHistoryDetails?.medical_history?.comments.split("\n").map((i: any, key: any) => {
                                    return <Text style={{marginLeft: 26}} key={key}>• {i}</Text>;
                                })}</View>
                            </View>}
                    </View>

                </View>
                <View style={{width: "50%"}}>
                    {medicalHistoryOptionsList?.slice(24, 48).map((option, index) => (
                        <View style={styles.checkboxContainer} key={option._id}>
                            <Checkbox checked={selectedIds.includes(option._id)}/>
                            <Text style={styles.label}>{option.title}</Text>
                        </View>
                    ))}

                </View>
            </View>
            <View break/>

        </View>
    );
};

export default MedicalHistoryPdf;

